// Age gate: opens the #age-gate dialog until the visitor confirms they're 21+.
(() => {
  const dialog = document.getElementById('age-gate');
  if (!dialog || document.documentElement.classList.contains('age-ok')) return;

  const days = Number(dialog.dataset.days) || 30;
  // Escape must not dismiss the gate.
  dialog.addEventListener('cancel', (e) => e.preventDefault());

  dialog.querySelector('[data-age-yes]').addEventListener('click', () => {
    const maxAge = days * 24 * 60 * 60;
    document.cookie = `hd_age_ok=1; max-age=${maxAge}; path=/; SameSite=Lax`;
    document.documentElement.classList.add('age-ok');
    dialog.close();
  });

  dialog.querySelector('[data-age-no]').addEventListener('click', () => {
    dialog.querySelector('[data-age-message]').hidden = true;
    dialog.querySelector('[data-age-actions]').hidden = true;
    const denied = dialog.querySelector('[data-age-denied]');
    denied.classList.remove('hidden');
    denied.focus?.();
  });

  if (typeof dialog.showModal === 'function') dialog.showModal();
  else dialog.setAttribute('open', '');
})();
